import useGetKeywordSearchHospitalInfiniteQuery from '@/hooks/search/hospital/useGetKeywordSearchHospitalInfiniteQuery';
import { parseSearchResultHospitalVo } from '@/parsers/search';
import { HospitalSortType } from '@/types/bff/gql-schema';

interface Props {
  keyword: string;
  latitude: number;
  longitude: number;
  size?: number;
  enabled?: boolean;
}
const HOSPITAL_SIZE = 50;
const useGetKeywordSearchHospitalInfinite = ({
  keyword,
  latitude,
  longitude,
  size = HOSPITAL_SIZE,
  enabled = true,
}: Props) => {
  const {
    data: hospitalData,
    isLoading: isHospitalLoading,
    hasNextPage: hasHospitalNextPage,
    fetchNextPage: fetchHospitalNextPage,
  } = useGetKeywordSearchHospitalInfiniteQuery(
    {
      request: {
        keyword,
        size,
        sortType: HospitalSortType.Distance,
        geoPoint: {
          latitude,
          longitude,
        },
      },
    },
    {
      select: (data) => {
        return {
          pages: parseSearchResultHospitalVo(data.pages),
          pageParams: data.pageParams,
        };
      },
      enabled:
        enabled && !!keyword && keyword.length > 0 && !!latitude && !!longitude,
    },
  );

  return {
    hospitalData,
    isHospitalLoading,
    hasHospitalNextPage,
    fetchHospitalNextPage,
  };
};

export default useGetKeywordSearchHospitalInfinite;
